
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { Dialog } from 'primereact/dialog';
import AddSectionMasterDialog from '../SectionMaster/AddSectionMaster';
import AddClassNoMasterDialog from '../ClassNoMaster/AddUpdateClassNoMaster';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddClassMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [className, setClassName] = useState('');
    const [visible, setVisible] = useState(false);
    const [classNovisible, setClassNoVisible] = useState(false);
    const [securityUserID, setSecurityUserID] = useState("");
    const [board, setBoard] = useState('');
    const [medium, setMedium] = useState('');
    const [sections, setSections] = useState('');
    const [classNameErrText, setClassNameErrText] = useState('');
    const [boardErrText, setBoardErrText] = useState('');
    const [mediumErrText, setMediumErrText] = useState('');
    const [classNameErr, setClassNameErr] = useState(false);
    const [boardErr, setBoardErr] = useState(false);
    const [mediumErr, setMediumErr] = useState(false);
    const [studentsCount, setStudentsCount] = useState([]);
    const [studentsCountErr, setStudentsCountErr] = useState(false);
    const [studentsCountErrText, setStudentsCountErrText] = useState('');
    const [totalCapacity, setTotalCapacity] = useState('');
    const [totalCapacityErr, setTotalCapacityErr] = useState(false);
    const [totalCapacityErrText, setTotalCapacityErrText] = useState('');
    const [sectionsList, setSectionList] = useState([]);
    const [mediumList, setMediumList] = useState([]);
    const [boardList, setBoardList] = useState([]);
    const [studentsList, setStudentsList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [type, setType] = useState('');
    const [typeErr, setTypeErr] = useState(false);
    const [typeErrText, setTypeErrText] = useState('');
    const [classNoList, setClassNoList] = useState([]);
    const [selectedYear, setSelectedYear] = useState(props?.financialYearId);
    const submitButtonRef = useRef(null);
    const classNameRef = useRef(null);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setClassName(props?.masterData?.ClassName);
        }
        setTimeout(() => {
            classNameRef.current?.focus();
        }, 100);
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                await GetLanguageList();
                await GetBoardList(loginData?._id);
                await GetClassNoList(loginData?._id);
                await GetTypeList(loginData?._id);
                await GetSectionDetailList(loginData?._id);
                await GetStudentsList(loginData?._id);
                if (props.ID) {
                    setClassName(props?.masterData?.ClassId);
                    setBoard(props?.masterData?.BoardName);
                    setMedium(props?.masterData?.Medium);
                    setSections(props?.masterData?.SectionName);
                    setStudentsCount(props?.masterData?.StudentsCount ? props?.masterData?.StudentsCount?.split(',') : []);
                    setTotalCapacity(props?.masterData?.TotalCapacity);
                    setType(props?.masterData?.Type);
                    setSelectedYear(props?.masterData?.AcademicYear ?? props?.financialYearId);
                    await GetAllStudentsList(loginData?._id,props?.masterData?.AcademicYear);
                }
                Loader.hide();
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const onCancel = () => {
        props.onCancel();
        setVisible(false);
        setClassNoVisible(false);
        setClassName('');
        setBoard('');
        setMedium('');
        setStudentsCount([]);
        setTotalCapacity('');
        setSections([]);
        GetSectionDetailList(securityUserID);
    }

    const GetLanguageList = async () => {
        try {
            await api.get(APIConstant.path.getLanguageList).then(async response => {
                let res = response;
                if (res.success) {
                    setMediumList(res?.data?.filter(y => y?.Status === 'Active')?.map(x => ({
                        ...x,
                        label: x?.LanguageName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetClassNoList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getClassNoList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassNoList(res?.data?.filter(x => x?.Status === 'Active'));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTypeList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getTypeList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTypeList(res?.data?.filter(x => x?.Status === 'Active')?.map(x => {
                        return {
                            label: x?.TypeName,
                            value: x?._id
                        }
                    }));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onSectionCancel = () => {
        setVisible(false);
        setSections([]);
        GetSectionDetailList(securityUserID);
    }

    const onClassNoCancel = () => {
        setClassNoVisible(false);
        setClassNoList([]);
        GetClassNoList(securityUserID);
    }

    const GetBoardList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getBoardList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setBoardList(res?.data?.filter(y => y?.Status === 'Active')?.map(x => ({
                        ...x,
                        label: x?.BoardName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetStudentsList = async (id) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: props?.financialYearId ?? selectedYear,
            }
            await api.post(APIConstant.path.getStudentDropDownList, data).then(async response => {
                let res = response;
                if (res.success) {
                    const filteredStudentsList = res?.data?.filter(x => x?.Status === 'Active')?.map(student => ({
                        ...student,
                        label: student?.Name,
                        value: student?._id,
                    }));

                    setStudentsList([...filteredStudentsList]);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetAllStudentsList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId ?? props?.financialYearId,
            }
            await api.post(APIConstant.path.getStudentDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    const studentData = props?.masterData?.StudentsCount ? props?.masterData?.StudentsCount?.split(',') : [];
                    const filteredStudentsList = res.data
                        .filter(student => studentData.includes(String(student?._id)))
                        .map(student => ({
                            ...student,
                            label: student?.Name,
                            value: student?._id,
                        }));

                    setStudentsList((prevList) => [...prevList, ...filteredStudentsList]);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetSectionDetailList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getSectionList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setSectionList(res?.data?.filter(x => x?.Status === 'Active'));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(className)) {
            formIsValid = false;
            setClassNameErr(true);
            setClassNameErrText("Class Name is required");
        } else {
            setClassNameErr(false);
            setClassNameErrText("");
        }
        if (CommonConfig.isEmpty(board)) {
            formIsValid = false;
            setBoardErr(true);
            setBoardErrText("Board is required");
        } else {
            setBoardErr(false);
            setBoardErrText("");
        }

        if (CommonConfig.isEmpty(medium)) {
            formIsValid = false;
            setMediumErr(true);
            setMediumErrText("Medium is required");
        } else {
            setMediumErr(false);
            setMediumErrText("");
        }
        return formIsValid;
    };

    const AddClassMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    ClassName: className,
                    BoardName: board ?? '',
                    Medium: medium ?? '',
                    SectionName: sections ?? '',
                    StudentsCount: studentsCount.length ? (studentsCount.length > 1 ? studentsCount.join(',') : studentsCount[0]) : '',
                    TotalCapacity: totalCapacity,
                    Type: type ?? '',
                    AcademicYear: selectedYear,
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateClassMaster, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '').trim().replace(/\s+/g, ' ');
        if (type === 'TotalCapacity') {
            setTotalCapacity(numericValue);
        }
    };

    const handleSectionChange = (e, type) => {
        setSections(e.value)
        let sectionData = sectionsList.filter(x => x?.value === e.value)[0];
        setTotalCapacity(sectionData?.TotalCapacity);
    }

    return <div>
        <div>
            <div className='p-grid'>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="sections">Class No<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <div className="p-d-flex p-ai-center">
                            <Dropdown
                                ref={classNameRef}
                                className="p-mt-1 p-pl-2 p-w-100"
                                id="classNo"
                                type="text"
                                maxLength={20}
                                placeholder="Select Class No"
                                options={classNoList}
                                value={className}
                                display="chip"
                                filter
                                onChange={(e) => setClassName(e.value)}
                            />

                            <span className="p-error block" style={{ color: 'red' }}>
                                {classNameErr ? classNameErrText : null}
                            </span>
                            <Button
                                className="e-btn white p-ml-2 p-mt-1 p-mb-0"
                                icon="pi pi-plus text-white"
                                onClick={(e) => setClassNoVisible(true)}
                            />
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="Board" >Board<span style={{ color: "red" }}>*</span></label>
                    <div className="p-mt-1 p-w-100">
                        <div className="custom-inputs p-w-100">
                            <Dropdown id="board" className='p-w-100' value={board} options={boardList} onChange={(e) => setBoard(e.value)} placeholder="Select Board" filter
                                showClear />
                        </div>
                        <span className="p-error block" style={{ color: 'red' }}>
                            {boardErr ? boardErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="Medium" className="p-mt-1">Medium<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <Dropdown
                            className="p-mt-1 p-w-100"
                            inputId="medium"
                            placeholder="Select Medium"
                            value={medium}
                            onChange={(e) => setMedium(e.value)}
                            options={mediumList}
                            optionLabel="label"
                            filter
                            showClear
                        />
                    </div>
                    <span className="p-error block" style={{ color: 'red' }}>
                        {mediumErr ? mediumErrText : null}
                    </span>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="Type" className="mr-2">Type</label>
                    <div className="custom-inputs">
                        <Dropdown
                            className="p-mt-1 p-w-100"
                            inputId="type"
                            placeholder="Select Type"
                            value={type}
                            onChange={(e) => setType(e.value)}
                            options={typeList}
                            optionLabel="label"
                            filter
                            showClear
                        />
                    </div>
                    <span className="p-error block" style={{ color: 'red' }}>
                        {typeErr ? typeErrText : null}
                    </span>
                </div>
                <div className="p-col-12  p-md-6 p-pt-2">
                    <label htmlFor="sections">Sections</label>
                    <div className="custom-inputs">
                        <div className="p-d-flex p-ai-center">
                            <Dropdown
                                id="sections"
                                value={sections}
                                options={sectionsList}
                                onChange={(e) => handleSectionChange(e)}
                                placeholder="Select Sections"
                                className="p-w-100 p-mt-1"
                                display="chip"
                                filter
                                showClear
                            />
                            <Button
                                className="e-btn white p-ml-2 p-my-0"
                                icon="pi pi-plus text-white"
                                onClick={(e) => setVisible(true)}
                            />
                        </div>
                    </div>

                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="studentsCount">Students Name: </label>
                    <div className="custom-inputs">
                        <MultiSelect
                            id="studentList"
                            value={studentsCount}
                            options={studentsList}
                            onChange={(e) => setStudentsCount(e.value)}
                            placeholder="Select Student"
                            className="p-mt-1 p-w-100"
                            filter
                            display="chip"
                        />
                        <span className="error-msg" style={{ color: 'red' }}>
                            {studentsCountErr ? studentsCountErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="totalCapacity">Total Capacity</label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                className="p-mt-1 p-w-100"
                                id="totalCapacity"
                                maxLength={5}
                                placeholder="Total Capacity"
                                value={totalCapacity}
                                onChange={(e) => handleChange(e, 'TotalCapacity')}
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {totalCapacityErr ? totalCapacityErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="selectedYear">Academic Years</label>
                        <Dropdown
                            id="selectedYear"
                            value={selectedYear}
                            options={props?.academicYearList}
                            onChange={(e) => setSelectedYear(e.value)}
                            placeholder="Select Academic Year"
                            display="chip"
                            className='p-w-100 p-mt-1'
                            filter
                            optionLabel="label"
                            optionValue="_id"
                            showClear
                        />
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                <Button className='btn-text-action-secondary' onClick={(e) => onCancel()}> Cancel </Button>
                <Button ref={submitButtonRef} className='btn-text-action-primary color-white submit-focus' label="Save" severity="secondary" raised onClick={(e) => AddClassMaster()} />
            </div>
            <Dialog
                header="Add Section Master"
                className='dialog-popup'
                visible={visible}
                onHide={() => onSectionCancel()}
                draggable={false}
                position="center"
            >
                <AddSectionMasterDialog masterData={[]} isEdit={false} ID={''} onCancel={onSectionCancel} />
            </Dialog>
            <Dialog
                header="Add Class No Master"
                className='dialog-popup'
                visible={classNovisible}
                onHide={() => onClassNoCancel()}
                draggable={false}
                position="center"
                style={{ width: '40vw' }}
            >
                <AddClassNoMasterDialog masterData={[]} isEdit={false} ID={''} onCancel={onClassNoCancel} />
            </Dialog>
        </div>
    </div>
};

export default AddClassMasterDialog;
